import { ActionReducer, MetaReducer } from '@ngrx/store';
import { utilLocalStorageReducer } from '@medlogic/shared/utils';
import { ExameResultadoActionTypes } from './exame-resultado.actions';
import { initialState } from './exame-resultado.reducer';

const KEY = 'MEDLOGIC_EXAME_RESULTADO_STATE';

// Includes the action types that must be persisted.
const PERSISTED_ACTIONS: string[] = [
  ExameResultadoActionTypes.LoadExameResultados
];

export function localStorageReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return utilLocalStorageReducer(reducer, PERSISTED_ACTIONS, KEY, initialState);
}

export const metaReducers: MetaReducer<any>[] = [localStorageReducer];
